<template>
	<div class="announcement-overview">
		<div class="report-container">
			<div class="report-box-item" v-for="item in listData" :key="item.index">
				<div class="report-wrapper" @click="goDetail(item)">
					<div class="report-wrapper-title text-overflow">{{ item.title }}</div>
					<div class="report-wrapper-footer">
						<div class="footer-left">
							<div class="type" v-if="item.classificationInfo">{{ item.classificationInfo }}</div>
							<p v-if="item.time" class="time">{{ item.time }}</p>
						</div>
						<SvgIcons class="enter-svg" name="enter" v-if="showIcon" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	listData: {
		type: Array,
		default: () => []
	},
	showIcon: {
		type: Boolean,
		default: false
	}
});
const emits = defineEmits(['goDetail']);

const goDetail = item => {
	emits('goDetail', item);
};
</script>

<style lang="less" scoped>
.report-box-item {
	display: flex;
	padding: 16px 0;
	border-bottom: 1px solid var(--border-lighter-color, #f2f3f5);

	.report-wrapper {
		overflow: hidden;
		width: 100%;
		&-title {
			color: var(--t-emphasis-color, #1d2129);
			width: 95%;

			font-size: 16px;

			font-weight: 500;
			line-height: 24px; /* 150% */
		}
		&-footer {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			margin-top: 8px;
			.footer-left {
				display: flex;
				.type {
					padding: 0px 4px;
					height: 18px;
					margin-right: 12px;

					background: var(--fill-normal-color, #f2f3f5);
					color: var(--t-secondary-color, #4e5969);

					font-size: 10px;

					font-weight: 400;
					line-height: 18px; /* 140% */
				}
				.time {
					color: var(--t-secondary-info-color, #86909c);

					font-size: 13px;

					font-weight: 400;
					line-height: normal;
				}
			}
			.enter-svg {
				width: 24px;
				height: 24px;
			}
		}
	}
}

.report-box-item:last-child {
	padding-bottom: 0;
	border: none;
}
.report-box-item:first-child {
	padding-top: 0;
}
</style>
